import { render, staticRenderFns } from "./ProjectBudget.vue?vue&type=template&id=ae67ffbe&"
import script from "./ProjectBudget.vue?vue&type=script&lang=js&"
export * from "./ProjectBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports